import { gql } from '@apollo/client';

// Geocoding queries
export const GEOCODE_ADDRESS = gql`
  query GeocodeAddress($address: String!) {
    geocodeAddress(address: $address) {
      latitude
      longitude
      formattedAddress
      zipCode
      timezone
      currentLocalTimeISO
      city
      state
    }
  }
`;

export const GET_AUTOCOMPLETE_PREDICTIONS = gql`
  query GetAutocompletePredictions($input: String!) {
    getAutocompletePredictions(input: $input) {
      placeId
      description
      mainText
      secondaryText
    }
  }
`;

export const GET_TIMEZONE_INFO = gql`
  query GetTimezoneInfo($zipCode: String!) {
    timezoneInfo(zipCode: $zipCode) {
      timezone
      currentLocalTimeISO
    }
  }
`;
